<template>
  <!-- Histórico documental REUTILIZABLE: panel que se despliega bajo el registro (fila de lista o
       fila de tabla con colspan). Muestra la versión actual + las anteriores, con descarga. Lo usan
       todos los sitios con subida de documentos (avales, seguros, facturas, change orders, docs...). -->
  <div class="fh">
    <div class="fh-head">
      <span>{{ $t('prm_summary_s02_pdf_history') }}</span>
      <button type="button" class="fh-close" @click="$emit('close')"><b-icon pack="fas" icon="xmark" size="is-small"></b-icon></button>
    </div>
    <div v-for="it in historyItems" :key="it.key" class="fh-row">
      <b-icon pack="fas" icon="file-pdf" size="is-small" class="fh-pdf"></b-icon>
      <span class="fh-ver">{{ $t('prm_summary_s02_pdf_version') }} {{ it.num }}</span>
      <span class="fh-name">{{ it.name }}</span>
      <span class="fh-date">{{ fmtDateTime(it.date) }}</span>
      <button type="button" class="fh-dl" @click="it.current ? download() : downloadVersion(it.versionId)">
        <b-icon pack="fas" icon="download" size="is-small"></b-icon><span>{{ $t('prm_summary_s02_pdf_download') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { fmtDate } from '../shared/format'

  export default {
    name: 'PrmFileHistory',

    props: {
      file: { type: Object, required: true },      // fichero actual con sus versiones
      baseUrl: { type: String, required: true },   // base .../dashboard-prm para las descargas
      projectId: { type: [Number, String], default: null },
    },

    computed: {
      // La actual (nº más alto) + las anteriores, más recientes primero.
      historyItems () {
        const file = this.file
        if (!file) return []
        const total = (file.versions ? file.versions.length : 0) + 1
        const items = [{ key: 'current', num: total, name: file.originalFilename, date: file.updatedAt, current: true }]
        ;(file.versions || []).forEach((v, i) => {
          items.push({ key: v.id, num: total - 1 - i, name: v.originalFilename, date: v.createdAt, versionId: v.id })
        })
        return items
      },
    },

    methods: {
      async download () {
        try {
          const { data } = await axios.get(`${this.baseUrl}/contract-files/${this.file.id}/download`)
          if (data && data.data) window.open(data.data)
        } catch (e) { this.$notify.error(this.$t('error_retrieving_data')) }
      },
      async downloadVersion (versionId) {
        try {
          const { data } = await axios.get(`${this.baseUrl}/contract-file-versions/${versionId}/download`)
          if (data && data.data) window.open(data.data)
        } catch (e) { this.$notify.error(this.$t('error_retrieving_data')) }
      },
      // Fecha y hora "DD/MM/YYYY, HH:MM".
      fmtDateTime (iso) {
        if (!iso) return ''
        const d = new Date(iso)
        if (isNaN(d.getTime())) return fmtDate(iso)
        const p = (n) => String(n).padStart(2, '0')
        return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}, ${p(d.getHours())}:${p(d.getMinutes())}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  .fh { border: 1px solid #e2e7ee; border-radius: 6px; overflow: hidden; background: #fff; }
  .fh-head {
    display: flex; align-items: center; justify-content: space-between; background: #f6f8fa;
    border-bottom: 1px solid #eef0f3; padding: 5px 10px;
    font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #33475f;
  }
  .fh-close { border: 0; background: transparent; color: #9aa4b2; cursor: pointer; padding: 0; }
  .fh-close:hover { color: #33475f; }
  .fh-row {
    display: flex; align-items: center; gap: 8px; padding: 6px 10px; font-size: 11px; color: #2c3a4d;
    border-bottom: 1px solid #f4f6f9;
  }
  .fh-row:last-child { border-bottom: 0; }
  .fh-pdf { color: #c0392b; flex-shrink: 0; }
  .fh-ver { font-weight: 700; color: #1e3046; white-space: nowrap; }
  .fh-name { color: #6b7787; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .fh-date { margin-left: auto; font-size: 10px; color: #9aa4b2; white-space: nowrap; }
  .fh-dl {
    display: inline-flex; align-items: center; gap: 4px; border: 1px solid #c3ccd8; background: #fff;
    color: #3d5570; font-size: 10px; font-weight: 600; padding: 3px 8px; border-radius: 5px; cursor: pointer; white-space: nowrap; flex-shrink: 0;
  }
  .fh-dl:hover { background: #f6f9fc; }
</style>
